import { BasicModel } from "@goodgamestudios/core";
import { TextFieldAutoSize } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Panel } from "../Poker2Panel";

import DisplayObject = createjs.DisplayObject;

import Point = createjs.Point;
import Shape = createjs.Shape;

export class Poker2TutorialInfo extends Poker2Panel {
    public static NAME: string = "Poker2TutorialInfo";

    private bubblePart: Shape;

    /**
     * btn_prev, btn_next, btn_close
     * txt_copy
     */

    /**
     * @param disp
     */
    constructor(disp: DisplayObject) {
        super(disp);
    }

    public show(): void {
        super.show();
    }

    /**
     * @param width		of window, text make height
     * @param x
     * @param y
     * @param btnNextEnable
     */
    public setWXYE(width: number, x: number, y: number, btnNextEnable: boolean = true): void {
        this.setSize(width);
        this.tutorialStepinfo.x = x;
        this.tutorialStepinfo.y = y;
        this.tutorialStepinfo.btn_next.enableButton = btnNextEnable;
        this.drawZipfel();

        if (btnNextEnable) {
            this.layoutManager.tutPanel.showTutorialArrow(null, true, true);
        }
    }

    /**
     * @param width
     */
    private setSize(width: number): void {
        const RAND: number = 8;
        var str: string;
        var height: number = NaN;

        // text
        this.tutorialStepinfo.txt_copy.width = width - 2 * RAND;

        this.tutorialStepinfo.txt_copy.autoSize = TextFieldAutoSize.LEFT;

        switch (this.tutorialController.tutorialState) {
            case "tut_step2_tableSelection":
                str = this.layoutManager.tutPanel.tableName;
                this.tutorialStepinfo.txt_copy.text = BasicModel.languageData.getTextById(this.tutorialController.tutorialState, [str]);
                break;
            case "tut_step3_playButton":
                str = "'" + Poker2Model.languageData.getTextById("lobby_btn_play_table") + "'";
                this.tutorialStepinfo.txt_copy.text = BasicModel.languageData.getTextById(this.tutorialController.tutorialState, [str]);
                break;
            case "tut_step5_buyIn":
                str = "'" + Poker2Model.languageData.getTextById("generic_btn_okay") + "'";
                this.tutorialStepinfo.txt_copy.text = BasicModel.languageData.getTextById(this.tutorialController.tutorialState, [str]);
                break;
            case "tut_step24_timoRaise":
                var tutBig: string = '50';
                str = BasicModel.languageData.getTextById(this.tutorialController.tutorialState, [tutBig]);
                str = str.split('10').join(tutBig);
                this.tutorialStepinfo.txt_copy.text = str;
                break;
            case "tut_step36_levelUp":
                if (Poker2Model.userData.tutorialCase == 1) {
                    // a)
                    this.tutorialStepinfo.txt_copy.text = BasicModel.languageData.getTextById("tut_step36a_levelUp");
                }
                else if (Poker2Model.userData.tutorialCase == 0) {
                    // b)
                    this.tutorialStepinfo.txt_copy.text = BasicModel.languageData.getTextById("tut_step36b_levelUp");
                }
                break;
            default:
                this.tutorialStepinfo.txt_copy.text = BasicModel.languageData.getTextById(this.tutorialController.tutorialState);
                break;
        }

        height = this.tutorialStepinfo.txt_copy.textHeight + 7 * RAND;
        this.tutorialStepinfo.txt_copy.x = RAND - width / 2;
        this.tutorialStepinfo.txt_copy.y = RAND - height / 2;
        // button
        this.tutorialStepinfo.btn_close.x = (width - this.tutorialStepinfo.btn_close.width) / 2;
        this.tutorialStepinfo.btn_close.y = -height / 2 - 10;
        this.tutorialStepinfo.btn_prev.x = 0;
        this.tutorialStepinfo.btn_prev.y = height / 2 - 3 * RAND;
        this.tutorialStepinfo.btn_next.x = 0;
        this.tutorialStepinfo.btn_next.y = height / 2 - 3 * RAND;
        // bg
        this.tutorialStepinfo.mc_bg.width = width;
        this.tutorialStepinfo.mc_bg.height = height;
    }

    /**
     */
    private drawZipfel(): void {
        var pAvatar: Point = new Point();
        pAvatar = this.layoutManager.tutPanel.tutorialPanel.mc_avatarPosition.localToGlobal(pAvatar);
        pAvatar = this.tutorialStepinfo.globalToLocal(pAvatar);

        // h == distance to the avatar
        var h: number = this.layoutManager.tutPanel.tutorialPanel.mc_avatarPosition.height / 2 - 20;
        var w: number = Math.atan2(pAvatar.y, pAvatar.x);
        var sin: number = Math.sin(w);
        var cos: number = Math.cos(w);
        pAvatar = new Point(pAvatar.x - cos * h, pAvatar.y - sin * h);
        // big == thickest point of the arrow
        var big: number = Math.min(Math.min(40, this.tutorialStepinfo.height), this.tutorialStepinfo.width);

        if (!this.bubblePart) {
            this.bubblePart = new Shape();
            this.bubblePart.mouseEnabled = false;
            this.tutorialStepinfo.addChildAt(this.bubblePart, 0);
        }

        this.bubblePart.graphics.clear();
        this.bubblePart.graphics.beginFill(0x96B9ED); // light blue
        this.bubblePart.graphics.moveTo(pAvatar.x, pAvatar.y);
        this.bubblePart.graphics.lineTo(-big * cos, big * sin);
        this.bubblePart.graphics.lineTo(big * cos, -big * sin);
        this.bubblePart.graphics.lineTo(pAvatar.x, pAvatar.y);
        this.bubblePart.graphics.endFill();
    }

    public updatePosition(): void {
        // nichts tun !!
    }

    //
    // getter & setter
    //

    protected get tutorialStepinfo(): Library.PokerTutorial.PokerTutorialStepinfo {
        return this.disp as Library.PokerTutorial.PokerTutorialStepinfo;
    }

    //
    // end
    //
}
import { Poker2TutorialController } from "../../../controller/Poker2TutorialController";
